<div *ngIf="showBanner && banners.length" [ngStyle]="{ 'pointer-events': 'none' }">
  <div *ngFor="let banner of banners" [ngStyle]="getBannerStyle(banner.type)"
    class="alert alert-success alert-dismissible fade show text-center mb-0" role="alert">
    <nr-icon [name]="getIcon(banner.type)" sizeClass="icon-size-24"></nr-icon>
    <span>{{ banner.message }}</span>
    <button type="button" *ngIf="banner.showCloseIcon" class="btn-close mt-2 me-1" data-bs-dismiss="alert" aria-label="Close" [ngStyle]="{ 'pointer-events': 'auto' }" (click)="bannerClose($event, banner.context)"></button>
  </div>
</div>